<template>
  <BaseCardV2
    class="pa-2"
    :btn-action="btnAction"
    :titre="'Ma synthèse'"
    @otherAction="onClickOtherAction"
    @on-help="isOpenModalHelp = true"
  >
    <div
      v-if="errorMessage"
      class="mb-4"
    >
      <BaseMessage
        type="error"
        color="error"
        :message="errorMessage"
      />
    </div>
    <div
      class="mb-2"
    >
      <div>
        <div
          class="d-flex
        align-center
        flex-column"
          :class="$vuetify.breakpoint.mobile ? 'mt-6' :'mt-16' "
        >
          <img
            src="@/assets/no-contrats.svg"
            alt="no-contrats"
          >
          <div
            class="intro texte-gris-fonce text-align-center mt-2"
            :class="$vuetify.breakpoint.mobile ? 'mb-6' :'mx-16' "
          >
            <span>Conservez la synthèse technico-économique des éléments marquants de votre exploitation</span>
          </div>
        </div>
      </div>
    </div>
    <HelpModal
      v-if="isOpenModalHelp"
      titre="Ma synthèse"
      :is-open-modal-help="isOpenModalHelp"
      @close="isOpenModalHelp = false"
    >
      <div slot="baseCardHelpContent">
        <div class="texte text-justify texte-gris-fonce pa-8" />
      </div>
    </HelpModal>

    <InformationAbonnementModal
      v-if="isOpenModalAideInformationAbonnement"
      :is-open-modal-information-abonnement="isOpenModalAideInformationAbonnement"
      code-feature="BILAN_ANNUEL"
      texte="Soyez accompagné par un expert pour faire le bilan de vos coûts et résultats de vos grandes cultures."
      titre="Bilan annuel de vos cultures"
      :is-conseiller-pv-affiche="!isAbonneCulturial"
      @close="isOpenModalAideInformationAbonnement = false"
    />
    <v-dialog
      v-model="isOpenModalSaisieSynthese"
      fullscreen
      transition="slide-x-transition"
      @click:outside="onCloseModal"
    >
      <SaisieSyntheseModal
        @close="onCloseModal"
      />
    </v-dialog>
  </BaseCardV2>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import BaseCardV2 from '@/components/card/base-card-v2.vue'
import BaseMessage from '@/components/common/base-message.vue'
import HelpModal from '@/components/modal/help-modal.vue'
import InformationAbonnementModal from '@/views/offre-abonnement/components/modal/information-abonnement-modal.vue'
import SaisieSyntheseModal from '../synthese/saisie-synthese-modal.vue'

export default {
  name: 'SyntheseVide',
  components: { BaseCardV2, BaseMessage, InformationAbonnementModal, HelpModal, SaisieSyntheseModal },
  data () {
    return {
      isOpenModalHelp: false,
      isOpenModalAideInformationAbonnement: false,
      isOpenModalSaisieSynthese: false,
      errorMessage: null
    }
  },

  computed: {
    ...mapGetters({
      abonnements: 'adherent/abonnements'
    }),
    isAbonneCulturial () {
      return this.abonnements.culturialAbonne
    },
    /*
     * Rien a rediger en vue mobile : la synthese s'y consulte seulement. Le
     * bouton disparait donc de la carte vide comme de la carte remplie.
     */
    btnAction () {
      return this.$roles.hasDroitEcritureAdminDte() && !this.$vuetify.breakpoint.mobile ? {
        libelle: 'Rédiger la synthèse',
        hasOtherAtion: true
      }: null
    }
  },
  methods: {
    ...mapActions({
      incrementerAccesSouscriptionAbonnement: 'accesSouscriptionAbonnement/incrementerAccesSouscriptionAbonnement',
      getSyntheseAnalyse: 'syntheseAnalyse/getSyntheseAnalyse'
    }),
    onClickOtherAction () {
      if (this.$roles.hasDTEWriteAccess()) {
        this.isOpenModalSaisieSynthese = true
      } else {
        this.isOpenModalAideInformationAbonnement = true
        this.incrementerAccesSouscriptionAbonnement('BILAN_ANNUEL')
      }
    },
    async onCloseModal () {
      this.isOpenModalSaisieSynthese = false
      this.errorMessage = null
      try {
        await this.getSyntheseAnalyse()
      } catch (error) {
        this.errorMessage = 'Une erreur est survenue lors du rafraîchissement de la synthèse.'
      }
    },
  }
}

</script>